<div class="container-fluid">
    <div class="row">
        <div class="col-xl-5">
            <div class="title-area">
                <h1 class="title" *ngIf="hiddenTitle">{{question.title}}</h1>
            </div>
            <div class="video-area" [attr.id]="'va' + question.id_question" (click)="videoPlayer(question.id_question)">
                <video (ended)="vidEnded()" webkit-playsinline playsinline autoplay loop class="video"
                    [attr.id]="'v' + question.id_question" [muted]="'muted'" #video>
                    <source [src]="question.url_video_question" type="video/mp4">
                </video>
                <div class="button-area">
                    <a href="javascript:void(0)" [attr.id]="'b' + question.id_question" class="play-button">
                        <img src="../../../assets/play_circle_filled_black_24dp.svg" alt="Botão de play">
                    </a>
                </div>
            </div>
            <div class="content">
                <div class="button-mute">
                    <a href="javascript:void(0)" (click)="muteVideo()" [attr.id]="'m' + question.id_question">
                        <img [attr.id]="'off' + question.id_question" src="../../../assets/volume_off.svg"
                            alt="botão de mute">
                        <img [attr.id]="'on' + question.id_question" hidden=true src="../../../assets/volume_up.svg"
                            alt="botão de mute">
                    </a>
                </div>
                <div class="text">
                    <h1>PliQplay</h1>
                </div>
            </div>
            <div class="progress" *ngIf="initVideo">
                <div [ngStyle]="objColor" [attr.id]="'progressbar-' + question.id_question" class="progress-color"
                    [style.animation]="animation"></div>
            </div>
        </div>
        <div class="col-xl-7">
            <ng-container *ngIf="!showIdentify ">
                <ng-container [ngSwitch]="question.fk_type_question">
                    <tpl-questions-nps *ngSwitchCase="1" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label" [form]="form" [objColor]="objColor"
                        (nextStep)="nextStepWizard()" class="question-area" [btnSubmit]="objVideoSettings.btnSubmit">
                    </tpl-questions-nps>
                    <tpl-feedback *ngSwitchCase="2" [form]="form" [objColor]="objColor"
                        (hiddenShowTitle)="hiddenShowTitle($event)" [btnSubmit]="objVideoSettings.btnSubmit"
                        (nextStep)="nextStepWizard()" class="text-area-mobile"></tpl-feedback>
                    <tpl-feedback *ngSwitchCase="3" [form]="form" [objColor]="objColor"
                        (hiddenShowTitle)="hiddenShowTitle($event)" [btnSubmit]="objVideoSettings.btnSubmit"
                        (nextStep)="nextStepWizard()" class="text-area-mobile"></tpl-feedback>
                    <tpl-yes-or-not *ngSwitchCase="5" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label" [form]="form" [objColor]="objColor"
                        (nextStep)="nextStepWizard()" class="question-area"></tpl-yes-or-not>
                    <tpl-five-stars *ngSwitchCase="6" [objColor]="objColor" [btnSubmit]="objVideoSettings.btnSubmit"
                        (nextStep)="nextStepWizard()" [form]="form" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label">
                    </tpl-five-stars>
                    <tpl-checkboxes *ngSwitchCase="8" [form]="form" [question]="question" [objColor]="objColor"
                        (nextStep)="nextStepWizard()"></tpl-checkboxes>
                    <tpl-questions-nps *ngSwitchCase="9" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label" [form]="form" [objColor]="objColor"
                        [btnSubmit]="objVideoSettings.btnSubmit" (nextStep)="nextStepWizard()" class="question-area">
                    </tpl-questions-nps>
                    <tpl-feedback *ngSwitchCase="10" [form]="form" [objColor]="objColor"
                        (hiddenShowTitle)="hiddenShowTitle($event)" [btnSubmit]="objVideoSettings.btnSubmit"
                        (nextStep)="nextStepWizard()" class="text-area-mobile"></tpl-feedback>
                    <tpl-radiolist *ngSwitchCase="11" [form]="form" [objColor]="objColor" [question]="question"
                        (nextStep)="nextStepWizard()"></tpl-radiolist>
                    <tpl-one-to-five-scale *ngSwitchCase="13" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label" [form]="form" [objColor]="objColor"
                        (nextStep)="nextStepWizard()" class="question-area"></tpl-one-to-five-scale>
                    <tpl-smiles *ngSwitchCase="15" [low_score_label]="question.low_score_label"
                        [high_score_label]="question.high_score_label" [form]="form" [objColor]="objColor"
                        (nextStep)="nextStepWizard()"></tpl-smiles>
                    <tpl-button-redirect *ngSwitchCase="16" [form]="form" [title_button]="question.title_button"
                        [objColor]="objColor" (nextStep)="nextStepWizard()"></tpl-button-redirect>
                    <tpl-info *ngSwitchCase="17" [form]="form" [title_button]="question.title_button"
                        [objColor]="objColor" (nextStep)="nextStepWizard()"></tpl-info>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="showIdentify">
                <tpl-identify [form]="formResponse" [type_contact_response]="survey.type_contact_response"
                    (nextStep)="nextStepWizard()" [objColor]="objColor" [btnSubmit]="objVideoSettings.btnSubmit"
                    [survey]="survey" (hiddenShowTitle)="hiddenShowTitle($event)">
                </tpl-identify>
            </ng-container>
        </div>
    </div>
</div>